module.exports = __webpack_public_path__ + "static/media/Plant-book.66b03e44.png";